<template>
    <div ref="slides" class="autoslides_cmp5hjm" :class="{'onScreen': onScreen, 'onScreenOnce': onScreenOnce}">
        <div ref="scroll_center" class="scrollcenter_handler"></div>

        <div v-if="component_data.static_bg" class="slide_cmp5hjm slide_bg_cmp5hjm" :style="(component_data.options.static_bg_style||'') + ('background-image: url('+component_data.static_bg+');')"></div>

        <transition-group tag="div" :name="animation_type" class="slides_cmp5hjm" :style="(component_data.options.wrapper_style||'') + (component_data.options.clip ? ('clip-path: ' + component_data.options.clip + ';') : '')">
            <div v-for="img in display" class="slide_cmp5hjm" :class="[slide_class, img.params.class]" :style="'background-image: url('+img.url+');animation-duration:'+duration+'ms;' + slide_style" :key="img.id" :id="img.id"></div>
        </transition-group>

        <div v-if="component_data.options.overlay" class="slide_cmp5hjm slide_bg_cmp5hjm" :style="(component_data.options.overlay_style||'') + ('background-image: url('+component_data.options.overlay+');')"></div>
        
    </div>
</template>

<script>
export default {
    props: ['component_data'],
    data(){
        return {
            imgset: [],
            images: [],
            display: [],
            current: 0,
            interval: 1200,
            duration: 800,
            timeout: null,
            play: true,
            at_once: 2,
            do_once: false,
            animation_type: 'slides',
            onscreen_playback: false,
            onScreenOnce: false,
            onScreen: false,
            runs: 0,
            slide_style: ''
        }
    },
    methods: {
        uid(){
            return Math.random().toString(36).substr(2, 5);
        },

        animate(){
            clearTimeout(this.timeout)
            this.timeout = null

            if(this.$refs.slides && this.$refs.slides.closest('.active_tabpanel')){
                this.stage(this.current)
                this.runs++
            

                if (this.imgset.length - 1 == this.current){
                    this.current = 0
                } 
                else {
                    this.current++
                }
            }

            if (this.do_once && this.runs >= this.images.length) this.play = false

            if (!this.play){return}

            this.timeout = setTimeout(()=>{
                this.animate()
            }, this.interval)            
        },

        isInViewport () {
            let element = this.$refs.scroll_center
            if (element) {
                var bounding = element.getBoundingClientRect();
                if (
                    element.closest('.active_tabpanel') &&
                    bounding.top >= 0 &&
                    bounding.left >= 0 &&
                    bounding.bottom <= (window.innerHeight + 80 || document.documentElement.clientHeight + 80) &&
                    bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
                ) {
                    this.onScreenOnce = true
                    this.onScreen = true
                    return true
                }
                this.onScreen = false
                return false
            }
        },

        animateIfInView(){
            if (!this.play){return}
            

            if (this.isInViewport()) {                
                this.animate()
            }            
        },

        stage(index){
            this.display.push(this.imgset[index])
            if (this.display.length > this.at_once){
                this.display.shift();
            }
        },

        addCss(){
            if(this.component_data.options.css){
                let styleBlock = document.createElement('style')
    
                styleBlock.innerHTML = this.component_data.options.css
    
                this.$refs.slides.appendChild(styleBlock)
            }
        }
    },
    watch:{
        onScreen(newVal){
            if(this.onscreen_playback && newVal && this.play){
                this.animate()
            }
        }
    },
    mounted() {
        if(this.component_data){
            if(this.component_data.options){
                this.at_once = this.component_data.options.at_once ? this.component_data.options.at_once : 2
                this.interval = this.component_data.options.interval ? this.component_data.options.interval : 1200
                this.duration = this.component_data.options.duration ? this.component_data.options.duration : 800
                this.animation_type = this.component_data.options.animation ? this.component_data.options.animation : 'slides'
                this.slide_style = this.component_data.options.slide_style ? this.component_data.options.slide_style : ''
                this.slide_class = this.component_data.options.slide_class ? this.component_data.options.slide_class : ''
                this.onscreen_playback = this.component_data.options.onscreen_playback ? this.component_data.options.onscreen_playback : false
                this.do_once = this.component_data.options.do_once ? this.component_data.options.do_once : false
                this.play = this.component_data.options.play ? this.component_data.options.play : true
            }
            this.addCss()  


            this.$nextTick(()=>{
                setTimeout(()=>{
                    this.isInViewport()
                }, 800)

                window.addEventListener('scroll', ()=>{
                    this.isInViewport()
                })

                            this.images = this.component_data.images ? this.component_data.images : ['https://via.placeholder.com/800x600?text=1', 'https://via.placeholder.com/800x600?text=2', 'https://via.placeholder.com/800x600?text=3']

            this.images.forEach((img)=>{
                let img_object = {id:this.uid()}
                if (img.url){
                    img_object.url = img.url
                    img_object.params = img.params ? img.params : {class: ''}
                } else {
                    img_object.url = img
                    img_object.params = {class: ''}
                }

                this.imgset.push(img_object)
            })
console.log(this.imgset)
    
                if(!this.onscreen_playback){
                    this.animate()
                } else {
                    this.animateIfInView()
                }

            })
        }
    }
}
</script>

<style>
    .scrollcenter_handler {
        background-color: transparent;
        width: 100px;
        height: 100px;
        position: absolute;        
        top: calc(50% - 50px);
        pointer-events: none;
    }


    .autoslides_cmp5hjm {
        height: 100%;
        width: 100%;
        position: relative;
    }
    .slides_cmp5hjm {
        height: 100%;
        width: 100%;
        position: relative;
    }

    .slide_cmp5hjm {
        width: inherit;
        height: inherit;
        position: absolute;
        top: 0; left: 0;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        -webkit-transform: translateZ(0);
        width: calc(100% + .49px);
        /* background-color: hotpink; */
    }

    .slides-enter-active {
        animation-name: slide_cmp5hjm;
        animation-fill-mode: both;
        animation-timing-function: ease-in;
    }
    .slides-leave-active {
        animation-name: slide_cmp5hjm;
        animation-fill-mode: both;
        animation-timing-function: ease-in;
        animation-direction: reverse;
    }
    @keyframes slide_cmp5hjm {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }

    .steam_slide {
        animation-name: steam_cmp5hjm;
        animation-fill-mode: both;
        animation-timing-function: ease-in;
    }
    @keyframes steam_cmp5hjm {
        0% {
            opacity: 0;
            transform: scale(.5) translateY(0%);
            animation-timing-function: ease-in;
        }
        33% {
            opacity: .4;
            transform: scale(.7) translateY(0%);
            animation-timing-function: ease-out;
        }
        100% {
            opacity: 0;
            transform: scale(1.3) translateY(0%);
            animation-timing-function: ease-in;
        }
    }
</style>
